import { IDeviceSize } from '@checkout/device';
import { IItem } from '@checkout/items';
import { ILoggedIn, IPaymentMethod, RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Sticky, StickyContainer } from 'react-sticky';
import { compose } from 'redux';
import { FlatCheckout, InformationBox, OrderHeader, OrderSummary, Overlay, Steps, Wallet } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { layoutTypes } from '../../../config/contextCheckoutConfig';
import { toggleMembershipOverlay } from '../../../reducers/checkout';
import { isKlarnaCheckoutAvailable } from '../../../utils/paymentMethods';
import CheckoutForm from '../CheckoutForm/CheckoutForm';
import { getQueryParametersAsObject as getUrlVars } from './../../../utils/apiUtils';
import { lg, md, sm, xs } from './../../../utils/utils';
import { Column, EmptyBagInfo, LoaderSpinner } from './../../presentational';
import * as Styles from './Layout.scss';

interface IOwnProps {
  items: IItem[];
}

interface IConnectedProps {
  loggedIn: ILoggedIn | null;
  paymentMethods: IPaymentMethod[];
  isPaymentMethodFetching: boolean;
  isShippingMethodFetching: boolean;
  isCountryFetching: boolean;
}

interface IConnectetDispatchProps {
  toggleMembershipOverlay: typeof toggleMembershipOverlay;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

interface IOwnState {
  deviceSize: IDeviceSize;
}

class Layout extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    deviceSize: {
      xs: true,
      sm: false,
      md: false,
      lg: false,
    },
  };

  componentWillMount() {
    this.handleCheckDeviceSize();
    window.addEventListener('resize', this.handleCheckDeviceSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleCheckDeviceSize);
  }

  handleCheckDeviceSize = () => {
    this.setState({
      deviceSize: {
        xs: xs(),
        sm: sm(),
        md: md(),
        lg: lg(),
      }
    });
  }

  handleMembershipOpen = () => {
    const { toggleMembershipOverlay: toggleOverlay } = this.props;
    toggleOverlay({ isOpen: true });
  }

  isWalletPage = () => getUrlVars(location.search).wallet;

  render() {
    const { intl, items, loggedIn, paymentMethods, isPaymentMethodFetching, isShippingMethodFetching, isCountryFetching } = this.props;
    const { deviceSize } = this.state;
    const noItemsInBag = !items || (items && items.length === 0);
    const isKCOAvailable = isKlarnaCheckoutAvailable(paymentMethods);
    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <StickyContainer>
            <Overlay />
            {(isPaymentMethodFetching || isShippingMethodFetching || isCountryFetching) && <LoaderSpinner width={70} height={70} withOverlay={true} />}
            {noItemsInBag && <EmptyBagInfo intl={intl} handleMembershipOpen={this.handleMembershipOpen} loggedIn={loggedIn} />}
            {!noItemsInBag && (
              <div className={Styles.wrap} is-klarna-checkout-available={isKCOAvailable ? 'true' : 'false'}>
                <div className={Styles.container}>
                  {deviceSize.md && (
                    <Sticky>
                      {({
                        style,
                        isSticky,
                        wasSticky,
                        distanceFromTop,
                        distanceFromBottom,
                        calculatedHeight
                      }) => (
                          <OrderHeader
                            isSticky={isSticky}
                            style={style}
                          />
                        )}
                    </Sticky>
                  )}
                  <div className={Styles.columns}>
                    <Column small={true}>
                      <OrderSummary deviceSize={deviceSize} />
                    </Column>
                    <Column>
                      <div className={Styles.content}>
                        {checkoutContextConfig.ui.informationBox.enabled && <InformationBox />}
                        {this.isWalletPage() && checkoutContextConfig.modules.wallet.isEnabled ? (
                          <Wallet />
                        ) : (
                            <Fragment>
                              {checkoutContextConfig.ui.layout.type === layoutTypes.flat &&
                                <CheckoutForm checkoutContextConfig={checkoutContextConfig}>
                                  <FlatCheckout deviceSize={deviceSize} />
                                </CheckoutForm>
                              }
                              {checkoutContextConfig.ui.layout.type === layoutTypes.steps &&
                                <Steps checkoutContextConfig={checkoutContextConfig} />
                              }
                            </Fragment>
                          )}
                      </div>
                    </Column>
                  </div>
                </div>
              </div>
            )}
          </StickyContainer>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      loggedIn: state.checkout.loggedIn,
      paymentMethods: state.checkout.paymentMethods,
      isPaymentMethodFetching: state.checkout.isPaymentMethodFetching,
      isShippingMethodFetching: state.checkout.isShippingMethodFetching,
      isCountryFetching: state.checkout.isCountryFetching,
    }),
    {
      toggleMembershipOverlay
    },
  )
)(Layout);
